import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  IWizItemRenderer,
  WizBaseCollector,
  WizCheckbox,
  WizDatasource,
  WizDropdown,
  WizHgroup,
  WizNumericInput,
  WizTextInput,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { FIELD_KIND, MathUtils } from '@wizeoo/akm-compute-lib';

import { AlkEvent } from '../../../../framework/events/alk.event';
import { ALK_EVENT_TYPE } from '../../../../model/enums';
import { ChartparameterObj } from '../../../wiz-ngx-charts/config/chart-parameter.obj';
import { ColorPickerPop } from '../../../colorpicker/color-picker.pop';


/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'chart-param-renderer',
  templateUrl: './chart-param.renderer.html',
})
export class ChartParamRenderer implements AfterViewInit, IWizItemRenderer<null, ChartparameterObj> {
  @ViewChild('paramGP', { read: WizHgroup, static: false }) paramGP: WizHgroup;
  @ViewChild('cbx') cbx: WizCheckbox;
  @ViewChild('ti') ti: WizTextInput;
  @ViewChild('ni') ni: WizNumericInput;
  @ViewChild('dd') dd: WizDropdown; // position de la légende

  public compoType: string = ''; // template en cours
  public currentValue: any = null;
  public labelField: string = '';
  public compoDS: WizDatasource<any> = new WizDatasource<any>([]).build();
  public maxNumber: number = null;
  public minNumber: number = null;

  constructor(protected cdref: ChangeDetectorRef, public elementRef: ElementRef) {}

  private _data: ChartparameterObj;
  public set data(value: ChartparameterObj) {
    this._data = value;
    // this.build();
    this.cdref.markForCheck();
  }
  public get data(): ChartparameterObj {
    return this._data;
  }
  public owner: WizBaseCollector;

  private _enabled: boolean = true;
  public set enabled(value: boolean) {
    this._enabled = value;
    this.cdref.markForCheck();
  }
  public get enabled(): boolean {
    return this._enabled;
  }

  ngAfterViewInit() {
    this.build();
    WizEventManager.addListener(this, this.paramGP, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateParams); // conf params
  }

  private updateParams(e: WizEvent): void {
    switch (this.compoType) {
      case FIELD_KIND.BOOLEAN:
        this.currentValue = this.cbx.wizChecked;
        break;
      case FIELD_KIND.STRING:
        this.currentValue = e.value;
        break;
      case FIELD_KIND.NUMBER:
        this.currentValue = e.value;
        break;
      case FIELD_KIND.COLOR:
        this.currentValue = e.value;
        break;  
      case 'dropdown':
        this.currentValue = this.compoDS.selectedItem[this.labelField];
        break;
    }
    this.data.value = this.currentValue;
    WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.CHART_UPDATE_PARAMETER, this));
  }

  private build(): void {
    setTimeout(() => {
      let compoType: string = null;
      if (this._data.kind === FIELD_KIND.STRING) {
        if (!!this._data.sourceCollection) {
          compoType = 'dropdown';
        } else {
          compoType = FIELD_KIND.STRING;
        }
      } else if (this._data.kind === FIELD_KIND.NUMBER || this._data.kind === FIELD_KIND.INT) {
        compoType = FIELD_KIND.NUMBER;
      } else {
        compoType = this._data.kind;
      }
      this.compoType = compoType;

      switch (compoType) {
        case FIELD_KIND.BOOLEAN:
          this.currentValue = JSON.parse(this._data.value);
          this.cbx.visible = true;
          this.cbx.wizChecked = this.currentValue;
          break;
        case FIELD_KIND.STRING:
          this.currentValue = this._data.value;
          this.ti.visible = true;
          this.ti.wizValue = this.currentValue;
          break;
        case FIELD_KIND.NUMBER:
          this.currentValue = this._data.value;
          this.maxNumber = this._data.maxValue;
          this.minNumber = this._data.minValue;
          this.ni.visible = true;
          this.ni.wizNumber = this.currentValue;
          break;
        case FIELD_KIND.COLOR:
          this.currentValue = this._data.value;
          this.colorpick.visible = true;
          break;
        case 'dropdown':
          this.labelField = this._data.sourceField;
          this.currentValue = this._data.value;
          this.compoDS.setItemCodeField(this.labelField);
          this.compoDS.setSource(this._data.sourceCollection);
          if (!!this.currentValue) {
            this.compoDS.select([this.compoDS.getItemByKey(this.currentValue)]);
          }
          this.dd.wizLabelField = this.labelField;
          this.dd.wizDataProvider = this.compoDS;
          this.dd.visible = true;
          break;
      }
    }, 0);
  }

  @ViewChild('colorpick', { read: WizHgroup, static: false }) colorpick: WizHgroup; // rendu hyperlink du FDV
  @ViewChild('cellBlockBack') cellBlockBack: ElementRef; // zone de dessin de la couleur de background
  public formatedValue: any = null; // la valeur formatée pour le rendu dans les composants 

  /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(this.cellBlockBack.nativeElement, pEvent.target, this.formatedValue, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    
    let realColor: string = MathUtils.RGBA2HEX(color);
    // console.log('backFromPicker', color, realColor);
    WizEventManager.dispatchEvent(this.paramGP, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, null, realColor));
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    WizEventManager.dispatchEvent(this.paramGP, new WizEvent(WIZ_EVENT_TYPE.MODEL_UPDATE, null, null));
    // console.log('resetColor', who);
  }

}
